import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context9; _forEachInstanceProperty(_context9 = ownKeys(Object(source), true)).call(_context9, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context10; _forEachInstanceProperty(_context10 = ownKeys(Object(source))).call(_context10, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useContext, useCallback, useMemo } from 'react';
import { selectorFamily, useRecoilValue, useRecoilCallback } from 'recoil';
import { formAtom, FormContext } from '../react-forms';
import { getIsDirty } from '../utils';
import { get as _get, set, cloneDeep } from 'lodash';

var _push = function _push() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var copy = _toConsumableArray(array);

  copy.push(field);
  return copy;
};

var _pop = function _pop() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var copy = _toConsumableArray(array);

  copy.pop();
  return copy;
};

var _unshift = function _unshift() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var copy = _toConsumableArray(array);

  copy.unshift(field);
  return copy;
};

var _insert = function _insert() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var copy = _toConsumableArray(array);

  _spliceInstanceProperty(copy).call(copy, index, 0, field);

  return copy;
};

var _replace = function _replace() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var copy = _toConsumableArray(array);

  copy[index] = field;
  return copy;
};

var _swap = function _swap() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var indexA = arguments.length > 1 ? arguments[1] : undefined;
  var indexB = arguments.length > 2 ? arguments[2] : undefined;

  var copy = _toConsumableArray(array);

  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};

var _move = function _move() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var from = arguments.length > 1 ? arguments[1] : undefined;
  var to = arguments.length > 2 ? arguments[2] : undefined;

  var copy = _toConsumableArray(array);

  var value = copy[from];

  _spliceInstanceProperty(copy).call(copy, from, 1);

  _spliceInstanceProperty(copy).call(copy, to, 0, value);

  return copy;
};

var _remove = function _remove() {
  var _context;

  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var index = arguments.length > 1 ? arguments[1] : undefined;
  return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(_sliceInstanceProperty(array).call(array, 0, index)), _toConsumableArray(_sliceInstanceProperty(array).call(array, index + 1, array.length)));
};

// TODO: Fix type
var fieldArraySelector = selectorFamily({
  key: 'fieldArray',
  get: function get(_ref) {
    var name = _ref.name,
        groupId = _ref.groupId,
        formId = _ref.formId;
    return function (_ref2) {
      var recoilGet = _ref2.get;

      var _recoilGet = recoilGet(formAtom({
        groupId: groupId,
        id: formId
      })),
          values = _valuesInstanceProperty(_recoilGet);

      return _get(values, name, []);
    };
  }
});

function useFieldArray(name) {
  var _useContext = useContext(FormContext),
      groupId = _useContext.groupId,
      formId = _useContext.id;

  var fieldArray = useRecoilValue(fieldArraySelector({
    name: name,
    groupId: groupId,
    formId: formId
  }));
  var setFieldArray = useRecoilCallback(function (_ref3) {
    var recoilSet = _ref3.set;
    return function (method, value) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      function setValue(prevState, nextState) {
        return nextState !== undefined ? set(cloneDeep(prevState), name, nextState) : prevState;
      }

      recoilSet(formAtom({
        groupId: groupId,
        id: formId
      }), function (prevForm) {
        var _context2, _context3, _context4, _context5, _context6;

        var fieldArrayInitialValues = _get(prevForm.initialValues, name);

        var fieldArrayValues = method.apply(void 0, _concatInstanceProperty(_context2 = [_get(_valuesInstanceProperty(prevForm), name)]).call(_context2, args, [// TODO: Fix type
        // eslint-disable-next-line
        // @ts-ignore
        value]));

        var largestArray = _reduceInstanceProperty(_context3 = [fieldArrayInitialValues, fieldArrayValues]).call(_context3, function (acc, arr) {
          if ((arr === null || arr === void 0 ? void 0 : arr.length) > acc.length) {
            return arr;
          }

          return acc;
        }, []);

        return _objectSpread(_objectSpread({}, prevForm), {}, {
          // TODO: Figure out how to add / remove field array names
          // names: ...,
          values: setValue(_valuesInstanceProperty(prevForm), fieldArrayValues),
          touched: setValue(prevForm.touched, // TODO: Fix type
          // eslint-disable-next-line
          // @ts-ignore
          method.apply(void 0, _concatInstanceProperty(_context4 = [_get(prevForm.touched, name)]).call(_context4, args, [false]))),
          isValidating: setValue(prevForm.isValidating, // TODO: Fix type
          // eslint-disable-next-line
          // @ts-ignore
          method.apply(void 0, _concatInstanceProperty(_context5 = [_get(prevForm.isValidating, name)]).call(_context5, args, [false]))),
          errors: setValue(prevForm.errors, // TODO: Fix type
          // eslint-disable-next-line
          // @ts-ignore
          method.apply(void 0, _concatInstanceProperty(_context6 = [_get(prevForm.errors, name)]).call(_context6, args, [null]))),
          isDirty: setValue(prevForm.isDirty, _mapInstanceProperty(largestArray).call(largestArray, function (_, index) {
            var _context7;

            return getIsDirty(_concatInstanceProperty(_context7 = "".concat(name, ".")).call(_context7, index), _get(fieldArrayInitialValues, index), _get(fieldArrayValues, index));
          }))
        });
      });
    };
  }, []);
  var push = useCallback(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    setFieldArray(_push, value);
  }, [setFieldArray]);
  var pop = useCallback(function () {
    setFieldArray(_pop, undefined);
  }, [setFieldArray]);
  var unshift = useCallback(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    setFieldArray(_unshift, value);
  }, [setFieldArray]);
  var insert = useCallback(function (index) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    setFieldArray(_insert, value, index);
  }, [setFieldArray]);
  var replace = useCallback(function (index) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    setFieldArray(_replace, value, index);
  }, [setFieldArray]);

  var _swap2 = useCallback(function (index, otherIndex) {
    setFieldArray(_swap, undefined, index, otherIndex);
  }, [setFieldArray]);

  var _move2 = useCallback(function (fromIndex, toIndex) {
    setFieldArray(_move, undefined, fromIndex, toIndex);
  }, [setFieldArray]);

  var _remove2 = useCallback(function (index) {
    setFieldArray(_remove, undefined, index);
  }, [setFieldArray]); // TODO: Make this perform better


  var fields = useMemo(function () {
    return _mapInstanceProperty(fieldArray).call(fieldArray, function (_, index) {
      var _context8;

      return {
        field: {
          name: _concatInstanceProperty(_context8 = "".concat(name, ".")).call(_context8, index)
        },
        actions: {
          swap: function swap(to) {
            _swap2(index, to);
          },
          move: function move(to) {
            _move2(index, to);
          },
          remove: function remove() {
            _remove2(index);
          }
        }
      };
    });
  }, [name, fieldArray, _swap2, _move2, _remove2]);
  var actions = useMemo(function () {
    return {
      push: push,
      pop: pop,
      unshift: unshift,
      insert: insert,
      replace: replace,
      swap: _swap2,
      move: _move2,
      remove: _remove2
    };
  }, [push, pop, unshift, insert, replace, _swap2, _move2, _remove2]);
  return [fields, actions];
}

export { useFieldArray };